import React, { useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Global, { isBusinessAccountType } from "../../util/Global";
import { useTranslation } from "react-i18next";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import { AlertContext } from "../../util/Alerter";
import { LoaderComponent } from "../../util/Loader";
import NotFound from "../../components/NotFound";
import { Search as SearchIcon } from '@mui/icons-material';


import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton,
    Typography, TextField,
    Avatar,
    Tooltip,
    Chip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Pagination from "../../components/Pagination";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { CurrencyContext, SortTabCell } from "../../components/Utils";
import { GlobalData } from "../../util/GlobalData";


export default function AdminProductsList() {

    const navigate = useNavigate();
    const [isLoading, setisLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const { t } = useTranslation();
    const { showAlert } = useContext(AlertContext)
    const [paginatedItems, setpaginatedItems] = useState([])
    const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)
    const [filteredItems, setfilteredItems] = useState([]);
    const [search, setSearch] = useState("");
    const [sortDirection, setSortDirection] = useState('desc');
    const [sortColumn, setSortColumn] = useState('date');
    const [sortedItems, setsortedItems] = useState([])
    const { currency,getCurrencyPrice } = useContext(CurrencyContext)

    const PRODUCTS_URL = Global.backend + "/index.php/produit/showall";
    const DELETE_PRODUCT_URL = Global.backend + "/index.php/produit/delete";




    useEffect(() => {
        setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
        setpageTitle("userList")
        setalertTitle("")
        setnavLinks([])
    }, [])


    useEffect(() => {
        setisLoading(true)

        axios.post(PRODUCTS_URL,{isAdminPanel:true}).then((response) => {
            setProducts(response.data)
        }).catch(() => {

        }).finally(() => {
            setisLoading(false)
        })
    }, []);


    useEffect(() => {
        setfilteredItems(
            products.filter(product =>
                product.nom.toLowerCase().includes(search.toLowerCase()) ||
                product.description.toLowerCase().includes(search.toLowerCase()) ||
                product.user.nom.toLowerCase().includes(search.toLowerCase()) ||
                product.user.prenom.toLowerCase().includes(search.toLowerCase()) ||
                product.user.entreprise?.nom.toLowerCase().includes(search.toLowerCase())
            )
        );
    }, [search, products])

    useEffect(() => {
        const sortedItems = [...filteredItems].sort((a, b) => {
            if (sortDirection === 'asc') {
                return a[sortColumn] > b[sortColumn] ? 1 : -1;
            } else {
                return a[sortColumn] < b[sortColumn] ? 1 : -1;
            }
        });
        setsortedItems(sortedItems)
    }, [sortDirection, sortColumn, filteredItems]);

    const handleSort = (column) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(column);
            setSortDirection('asc');
        }
    }


    const alertShow = (alertText, callback) => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success ml-3",
                cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
        });

        swalWithBootstrapButtons
            .fire({
                title: t("alertTitle.confirm"),
                text: alertText,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: t("alertButton.ok"),
                cancelButtonText: t("alertButton.cancel"),
                reverseButtons: true,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    callback()
                }
            });
    };








    function handleDelete(produitId) {
        alertShow(t("deleteProduct"), () => {
            setisLoading(true)
            axios.post(DELETE_PRODUCT_URL, { produitId })
                .then(() => {
                    showAlert("success", t("request.successDeleteProduct"))
                    setProducts(products.filter(product => product.id != produitId))
                }).catch(() => {
                    showAlert("error", t("request.errorDeleteProduct"))
                }).finally(() => {
                    setisLoading(false)
                })
        })
    }











    return (
        <LoaderComponent isLoading={isLoading}>
            {!isLoading && (
                !products.length ? <NotFound /> :
                    <div className="container-fluid">
                        <div className="row">
                            <div className="card">
                                <div className="card-body">
                                    <TextField
                                        label="Search"
                                        variant="outlined"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        fullWidth
                                        margin="normal"
                                        InputProps={{
                                            endAdornment: (
                                                <IconButton>
                                                    <SearchIcon />
                                                </IconButton>
                                            ),
                                        }}
                                    />

                                    {!paginatedItems.length ? <NotFound /> :
                                        <TableContainer component={Paper} className="mt-3">
                                            <Table>
                                                <TableHead>
                                                    <TableRow >
                                                        <TableCell>{t("product.image")}</TableCell>
                                                        <SortTabCell title={t("productName")} label={"nom"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                                                        <TableCell>{t("clientDetails")}</TableCell>
                                                        <SortTabCell title={t("product.stock")} label={"stock"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                                                        <TableCell>{t("productCurrency")}</TableCell>
                                                        <SortTabCell title={t("product.prix")} label={"prix"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                                                        <SortTabCell title={t("product.visibilite")} label={"visibilite"} sortColumn={sortColumn} sortDirection={sortDirection} onClick={handleSort} />
                                                        <TableCell>{t("action")}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {paginatedItems.map((product, index) => (
                                                        <TableRow key={index} selected={product.user.id == localStorage.getItem("id")}>
                                                            <TableCell>
                                                                <Avatar
                                                                    src={product.image.length ? `${Global.backend}/uploads/${product.image[0].imageURL}` : require("../../assets/img/default_product.png")}
                                                                    alt="Product"
                                                                    sx={{ width: 100, height: 100 }}
                                                                >{product.nom[0]}</Avatar></TableCell>
                                                            <TableCell>{product.nom}</TableCell>
                                                            <TableCell><Typography color={"primary"} sx={{ fontWeight: "bold" }}>{isBusinessAccountType(product.user.compte) ? product.user.entreprise?.nom : ""}</Typography> ({product.user.prenom} {product.user.nom}) <Typography color={"secondary"} sx={{ fontWeight: "bold" }}>{product.user.id == localStorage.getItem("id") ? "(" + t("me") + ")" : ""}</Typography></TableCell>
                                                            <TableCell>{product.stock}</TableCell>
                                                            <TableCell>{product.currency}</TableCell>
                                                            <TableCell>
                                                                <div style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    fontSize: 17
                                                                }}
                                                                >
                                                                    {product.discount ? (
                                                                        <span
                                                                            className="rounded-pill bg-success mr-1"
                                                                            style={{ color: "white" }}
                                                                        >
                                                                            {GlobalData.currency[currency]}{getCurrencyPrice(product.prix - (product.prix * product.discount / 100),product.currency)}
                                                                        </span>
                                                                    ) : (
                                                                        <span
                                                                            className="badge rounded-pill bg-success mr-1"
                                                                            style={{ color: "white" }}
                                                                        >
                                                                            {GlobalData.currency[currency]}{getCurrencyPrice(product.prix,product.currency)}
                                                                        </span>
                                                                    )}

                                                                    {product.discount && (
                                                                        <span>
                                                                            <span
                                                                                style={{
                                                                                    backgroundColor: "red",
                                                                                    color: "white",
                                                                                    padding: 2,
                                                                                    borderRadius: 5,
                                                                                    fontWeight: "bold",
                                                                                }}
                                                                                className="mr-1"
                                                                            >
                                                                                -{product.discount}%
                                                                            </span>


                                                                            <a className="text-muted">
                                                                                <span
                                                                                    style={{
                                                                                        textDecoration: "line-through",
                                                                                    }}
                                                                                >
                                                                                    {GlobalData.currency[currency]}{getCurrencyPrice(product.prix,product.currency)}
                                                                                </span>
                                                                            </a>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </TableCell>
                                                            <TableCell><Chip className="ml-2" label={t(product.visibilite ? "product.visible" : "product.invisible")} color={product.visibilite ? "success" : "error"} /></TableCell>
                                                            <TableCell>
                                                                <Tooltip title={t("view")}>
                                                                    <IconButton
                                                                        color="info"
                                                                        onClick={() => navigate("/dashboard/admin/product/" + product.id)}
                                                                    >
                                                                        <VisibilityIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title={t("delete")}>
                                                                    <IconButton
                                                                        color="error"
                                                                        onClick={() => handleDelete(product.id)}
                                                                    >
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    }


                                    <Pagination itemsPerPage={10} items={sortedItems} setItems={setpaginatedItems} />
                                </div>
                            </div>
                        </div>
                    </div>

            )

            }
        </LoaderComponent>
    )
}